import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box, Grid } from '@chakra-ui/react';
import { RFNodeIcon, RFSvg } from '../../base';
import { useNodeTemplate } from '../../../hooks';
import { RFConfigContext } from '../../../contexts';
import { COMPRESSOR_CONFIG } from './RFCompressorNode.config';
/**
 * Component renders "compressor" type of node of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_NODE_TYPES.
 */
const RFCompressorNodeFC = ({ id, data, type, selected, isConnectable = true }) => {
    const { isInspector } = useContext(RFConfigContext) ?? {};
    const { isValidTemplate, renderPorts, renderError } = useNodeTemplate({
        id,
        selected,
        templateCode: data.templateCode,
        config: COMPRESSOR_CONFIG
    });
    return isValidTemplate ? (_jsxs(_Fragment, { children: [_jsxs(Grid, { "data-templateid": data.templateCode, templateRows: "auto auto", gap: "4px", children: [_jsx(RFNodeIcon, { id: id, rfType: type, isSelected: selected, isInspector: isInspector, templateCode: data.templateCode ?? '', children: _jsx(RFSvg, { name: COMPRESSOR_CONFIG.icon, width: 70, height: 58 }) }), _jsx(Box, { p: "0 8px", w: "84px", textAlign: "center", fontSize: "12px", lineHeight: "14px", fontWeight: 700, className: "cut-text", children: data.title })] }), renderPorts(isConnectable, isInspector)] })) : (_jsx(_Fragment, { children: renderError() }));
};
export const RFCompressorNode = RFCompressorNodeFC;
//# sourceMappingURL=RFCompressorNode.js.map